/**
 * Tailwind-variants definition for `<ToolGridV4>`. Lives in a sibling file
 * (not in `ToolGrid.v4.tsx`) so the component file only exports components
 * — required by `react-refresh/only-export-components` for HMR to work
 * without forcing a full reload on style edits.
 */
import { tv, type VariantProps } from 'tailwind-variants';

export const toolGridV4Variants = tv({
  base: 'contents',
});

export type ToolGridV4VariantProps = VariantProps<typeof toolGridV4Variants>;
